import { ApiClient } from '@/services/api.service';

class EventsApi {
    async updateUserEvent(action: string, payload: Record<string, any> = {}) {
        const { data } = await ApiClient.post('/events/', {
            event_type: {
                event: action,
            },
            ...payload
        });

        console.warn(`USER_EVENT: ${action} -`, data);
    }

    logUserEventWithoutResponse(action: string, payload: Record<string, any> = {}) {
        ApiClient.post('/events/', {
            event_type: {
                event: action,
            },
            ...payload
        });

        console.warn(`USER_EVENT: ${action}`);
    }
}

export const eventsApi = new EventsApi();
